import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferralFromSearch } from "@/lib/referral";

/** Renders nothing. Mount once inside <BrowserRouter>; stores ?ref=CODE from any landing URL. */
export default function ReferralCapture() {
  const { search } = useLocation();
  useEffect(() => {
    if (search) captureReferralFromSearch(search);
  }, [search]);
  return null;
}
